// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__r63rr","item":"PaymentsMobile_item__1XPny","label":"PaymentsMobile_label__1FuCb","amount":"PaymentsMobile_amount__1Sq62"};